export default "__VITE_ASSET__BquZO9jD__"